// Replace shortcode in format [variable-varName] with the value of varName from the context
export function substituteShortcodes(content, aLContext) {
  const shortcodeRegex = /\[variable-([^\]]+)\]/g;
  let processedContent = content;
  let match;

  while ((match = shortcodeRegex.exec(content)) !== null) {
    const varName = match[1];
    // Explicitly check for undefined
    const varValue = aLContext.currentContext[varName] !== undefined ? aLContext.currentContext[varName] : '';
    // Ensure conversion to string
    processedContent = processedContent.replace(match[0], varValue.toString());
  }

  return processedContent;
}
